import React from 'react';
import SettingsPage from '../../components/settings/SettingsPage';

const sections = [
    {
        key: 'social',
        titleEn: 'Social Media',
        titleAr: 'وسائل التواصل الاجتماعي',
        descriptionEn: 'Social media links and WhatsApp number.',
        descriptionAr: 'روابط السوشيال ميديا ورقم الواتساب.',
        fieldOrder: ['facebook', 'twitter', 'instagram', 'linkedin', 'youtube', 'whatsapp'],
        alwaysShow: true,
    },
];

const ContactSettings = () => (
    <SettingsPage
        titleEn="Contact Settings"
        titleAr="بيانات التواصل"
        descriptionEn="Manage social media links displayed on the site."
        descriptionAr="إدارة روابط السوشيال ميديا الظاهرة في الموقع."
        sections={sections}
    />
);

export default ContactSettings;
